import { isoToDateString, isoToDateTimeString } from "utils/date";

export default [
  { field: 'name', headerAlign: 'center', headerName: 'Касса', width: 160,
    valueGetter: (value, row) => `${row.model} - ЗН ${row.factoryNumber}`},
  { field: 'connectedAt', headerAlign: 'center', headerName: 'Подключена', width: 120,
    valueGetter: (value) => isoToDateTimeString(value)},  
  { field: 'lastConnectedAt', headerAlign: 'center', headerName: 'Связь', width: 120,
    valueGetter: (value) => isoToDateTimeString(value)},  
  { field: 'license', flex: 1, headerAlign: 'center', headerName: 'Лицензия', align: 'center' },
  { field: 'licenseEndAt', headerAlign: 'center', headerName: 'Лицензия до', width: 100,
    valueGetter: (value) => isoToDateString(value), align: 'right'},  
];    